<mat-toolbar id="app-toolbar" fxLayout="row" fxLayoutAlign="space-between center">
    <div fxFlex="16" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="sync-btn" (click)="sync()" *ngIf="showSyncIcon">
          <mat-icon>cloud_sync</mat-icon>
      </button>
    </div>
    <div fxFlex="68" fxLayout="row" fxLayoutAlign="center center">
      <div class="logo"></div>
    </div>
    <div fxFlex="16" fxLayout="row" fxLayoutAlign="end center">
      <!-- <button mat-icon-button class="radar-icon" (click)="scanDevices()">
        <mat-icon>radar</mat-icon>
      </button> -->
    </div>
</mat-toolbar>
